// AUTO-GENERATED by scripts/generate-api-mappings.py — do not edit manually
import { ApiTarget } from '../environment/api-environment.model';

export interface ApiRouteOverrideRule {
  path: string;
  target: ApiTarget;
}

/** Checked before prefix rules. Use for routes that break prefix conventions. */
export const API_ROUTE_OVERRIDES: ReadonlyArray<ApiRouteOverrideRule> = [
];
